import React from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import landingPageRoutes from 'views/LandingPage/routes';
import dashboardPageRoutes from 'views/Dashboard/routes';
import adminPageRoutes from 'views/DashboardAdmin/routes';
import judgePageRoutes from 'views/DashboardJudge/routes';
import operatorPageRoute from 'views/DashboardOperator/routes';
import groupPageRoute from 'views/DashboardGroup/routes';
import RequireAuth from './utils/RequireAuth';
import RequireAdmin from 'utils/RequireAdmin';
import RequireOperator from 'utils/RequireOperator';
import RequireGroup from 'utils/RequireGroup';
import DashboardLayout from 'layouts/Dashboard/DashboardLayout';
import RequireJudge from 'utils/RequireJudge';

const Routes = () => {
    return (
        <ReactRoutes>
            {landingPageRoutes.map((item, i) => (
                <Route key={i} path={item.path} element={item.renderer()} />
            ))}

            {dashboardPageRoutes.map((item, i) => (
                <Route
                    key={i}
                    path={item.path}
                    element={<RequireAuth>{item.element}</RequireAuth>}
                />
            ))}

            {groupPageRoute.map((item, i) => (
                <Route
                    key={i}
                    path={item.path}
                    element={
                        <RequireGroup>
                            <DashboardLayout>{item.element}</DashboardLayout>
                        </RequireGroup>
                    }
                />
            ))}

            {operatorPageRoute.map((item, i) => (
                <Route
                    key={i}
                    path={item.path}
                    element={
                        <RequireOperator>
                            <DashboardLayout>{item.element}</DashboardLayout>
                        </RequireOperator>
                    }
                />
            ))}

            {judgePageRoutes.map((item, i) => (
                <Route
                    key={i}
                    path={item.path}
                    element={
                        <RequireJudge>
                            <DashboardLayout>{item.element}</DashboardLayout>
                        </RequireJudge>
                    }
                />
            ))}

            {adminPageRoutes.map((item, i) => (
                <Route
                    key={i}
                    path={item.path}
                    element={
                        <RequireAdmin>
                            <DashboardLayout>{item.element}</DashboardLayout>
                        </RequireAdmin>
                    }
                />
            ))}

            <Route
                path="*"
                element={<Navigate replace to="/not-found-cover" />}
            />
        </ReactRoutes>
    );
};

export default Routes;
